import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import Swup from 'swup';
import SwupScrollPlugin from '@swup/scroll-plugin';
import SwupPreloadPlugin from '@swup/preload-plugin';
import SwupSlideTheme from '@swup/slide-theme';
import SwupScriptsPlugin from '@swup/scripts-plugin';
import SwupHeadPlugin from '@swup/head-plugin';
import SwupA11yPlugin from '@swup/a11y-plugin';

UIkit.use(Icons);

const swup = new Swup({
    containers: ['#swup', '.navbar-right li'],
    linkSelector:
        'a[href^="' +
        window.location.origin +
        '"]:not([data-no-swup]),' +
        'a[href^="/"]:not([data-no-swup]):not([target="_blank"]):not(.rex-minibar-close):not(.rex-minibar-opener),' +
        'a[href^="#"]:not([data-no-swup]):not([target="_blank"])',
    animateHistoryBrowsing: true,
    plugins: [
        new SwupScrollPlugin({
            animateScroll: false
        }),
        new SwupSlideTheme({
            reversed: true
        }),
        new SwupPreloadPlugin(),
        new SwupHeadPlugin(),
        new SwupA11yPlugin({
            announcementTemplate: "Navigiert zu: {title}",
            urlTemplate: "Neue Seite unter {url}"
        }),
        new SwupScriptsPlugin({
            head: false,
            body: true
        }),
    ]
});

window.addEventListener('load', init);
swup.on('pageView', init);
swup.on('animationOutStart', hideOffcanvas)
swup.on('samePage', hideOffcanvas);

function init() {
    let boxReloadLink = document.querySelector('.consent_manager-show-box-reload');

    if (boxReloadLink) {
        boxReloadLink.addEventListener('click', () => {
            consent_manager_parameters.forcereload = 1;
            consent_manager_showBox();
        })
    }
}

function hideOffcanvas() {
    UIkit.offcanvas('.mobile-navigation').hide();
}